module.exports = "/_next/static/files/eaf5a9cb9f955a9f6eb36058b37f9112.gif";